/**
 * Created by Shuhin on 3/28/20.
 */

import React from 'react';
import { Map } from 'immutable';
import api from '../utility/api';
import List from '../screens/list';
import { connect } from 'react-redux';
import appConstants from '../utility/app-constants'
import { asyncStart, asyncEnd, showFeedback } from '../actions/application';
import { getListUIPreference, setListUIPreference } from '../utility/local-storage';
import { isConnected, setDoctorUpdater, unsetDoctorUpdater } from '../utility/socket-handler';

class VisitingDoctorsList extends React.Component {

  constructor() {
    super(...arguments);
    let {defaultSort, pageSize} = this.loadUIPreferences();
    this.state = {
      socketConnection: '',
      doctorMap: Map(),
      sortPref: defaultSort,
      pageSize
    };
  }

  componentDidMount() {
    this.getVisitingDoctorsList()
      .then(() => {
        setDoctorUpdater({
          add: (doctor) => this.addDoctor(doctor),
          remove: (id) => this.removeDoctor(id),
          online: () => this.setState({ socketConnection: 'ONLINE' }),
          offline: () => this.setState({ socketConnection: 'OFFLINE' })
        });

        this.setState({socketConnection: isConnected() ? 'ONLINE' : 'OFFLINE'});
      });
  }

  componentWillUnmount() {
    unsetDoctorUpdater();
  }

  addDoctor(doctor) {
    const map = this.state.doctorMap.set(doctor.id, doctor);
    this.setState({doctorMap: map});
  }

  removeDoctor(doctorId) {
    const map = this.state.doctorMap.remove(doctorId);
    this.setState({doctorMap: map});
  }

  loadUIPreferences() {
    let listPreference = getListUIPreference(appConstants.LIST.VISITING_DOCTORS);
    let defaultSort = listPreference && listPreference.sortPref? listPreference.sortPref :
      [
        {
          id: 'userName',
          desc: false
        }
      ];
    let pageSize = listPreference && listPreference.sortPref ? listPreference.pageSize : 20;

    return {defaultSort, pageSize};
  }

  onSortedChange(newSorted){
    let currentPreference = getListUIPreference(appConstants.LIST.VISITING_DOCTORS);
    currentPreference = currentPreference || {};
    currentPreference.sortPref = newSorted;
    setListUIPreference(appConstants.LIST.VISITING_DOCTORS, currentPreference);
  }

  onPageSizeChange(pageIndex) {
    let currentPreference = getListUIPreference(appConstants.LIST.VISITING_DOCTORS);
    currentPreference = currentPreference || {};
    currentPreference.pageSize = pageIndex;
    setListUIPreference(appConstants.LIST.VISITING_DOCTORS, currentPreference);
  }

  getVisitingDoctorsList() {
    this.props.dispatch(asyncStart());
    return api.getVisitingDoctors()
      .then(doctorMap => {
        this.props.dispatch(asyncEnd());
        this.setState({ doctorMap });
      })
      .catch(error => {
        this.props.dispatch(asyncEnd());
        this.props.dispatch(showFeedback({message: error.message}));
      });
}

  render() {

    const columns = [{
      Header: 'Id',
      accessor: 'id',
      show: false
    }, {
      id: 'userName',
      Header: 'Name',
      accessor: 'user.name'
    }, {
      id: 'userPhone',
      Header: 'Phone',
      accessor:'user.phone'
    }, {
      id: 'userEmail',
      Header: 'Email',
      accessor: 'user.email'
    }, {
      Header: 'Passed From',
      accessor: 'passed_from'
    }, {
      Header: 'Passing Year',
      accessor: 'passing_year'
    }];

    let {doctorMap, sortPref, pageSize, socketConnection} = this.state;
    let {isLoading} = this.props.application;
    let reactTableProps = {
      data: doctorMap.toArray(),
      columns,
      isLoading,
      noDataText: 'No doctors found',
      defaultSorted: sortPref,
      defaultPageSize: pageSize,
      onSortedChange: this.onSortedChange.bind(this),
      onPageSizeChange: this.onPageSizeChange.bind(this)
    };

return (
  <List
    title="Doctors Online"
    addNewBadge={socketConnection}
    reactTableProps={reactTableProps}
 />
  )
 }
}

function mapStateToProps(state) {
  return {
    application: state.application,
    user: state.user
  }
}

export default connect(mapStateToProps, null)(VisitingDoctorsList);



// WEBPACK FOOTER //
// ./src/containers/visiting-doctors.js